const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const { margin, title, subtitle } = attributes;

  return (
    <section className={`AboutUs-card ${margin}`}>
      <div className="about-us-cards-content Container">
        <div className="about-us-cards-text">
          <RichText.Content
            tagName="h2"
            className="Typography title-5 left color-blue-dark  margin-small"
            value={title}
          />
          <RichText.Content
            tagName="p"
            className="Typography text left color-black margin-none"
            value={subtitle}
          />
        </div>
        <div className="about-us-cards-swiper__cards about-us-cards-swiper margin-medium">
          <div className="swiper-wrapper">
            <InnerBlocks.Content />
          </div>
        </div>
      </div>
    </section>
  );
};
